"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryContent = void 0;
var _react = require("react");
var _navigation = require("../../../context/navigation");
var _hooks = require("../../../hooks");
var _models = require("../../../models");
var _utils = require("../../../utils");
var _CategoryContentSkeleton = require("./CategoryContentSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const GeneratedMobileBurgerMenuSubLinks = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_GeneratedMobileBurgerMenuSubLinks" */'./MobileSubLinksGenerator'))));
const GeneratedDesktopBurgerMenuSubLinks = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_GeneratedDesktopBurgerMenuSubLinks" */'./DesktopSubLinksGenerator'))));
const CategoryContent = () => {
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    activeLink
  } = (0, _navigation.useActiveLink)();
  const {
    shopSectionItems: items,
    loadingShopSectionItems: loading
  } = (0, _navigation.useBurgerMenu)();
  if (loading || items.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryContentSkeleton.CategoryContentSkeleton, {
      animation: loading ? 'pulse' : undefined
    });
  }
  const activeCategory = Object.values(_models.Categories).find(cat => (0, _utils.stripSlashes)(activeLink?.url).endsWith(cat));
  const category = items.find(cat => (0, _utils.stripSlashes)(cat.url).endsWith(activeCategory));
  const subCategories = category?.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CategoryContentSkeleton.CategoryContentSkeleton, {}),
    children: isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(GeneratedMobileBurgerMenuSubLinks, {
      subCategories: subCategories,
      activeCategory: activeCategory
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(GeneratedDesktopBurgerMenuSubLinks, {
      subCategories: subCategories
    })
  });
};
exports.CategoryContent = CategoryContent;
//# sourceMappingURL=CategoryContent.js.map